module.exports = __webpack_public_path__ + "img/dboml.ff052350.png";